import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { HubspotAuthService } from '../services/hubspot-auth-service';
import { mergeMap, take, tap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const hubspotAuthService = inject(HubspotAuthService);

  if (request.url.includes('/v1/hubspot')) {
    return next(request);
  }

  return hubspotAuthService.authHeaders$.pipe(
    take(1),
    mergeMap((authData) => {
      if (authData) {
        request = request.clone({
          headers: request.headers.set(authData.key, authData.value),
        });
      }
      return next(request);
    }),
  );
};
